import { Button, Drawer, Image, Tooltip, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { UserInfo } from "../../../../context";
import LogoImg from "./../../../../assets/tinyimg/logo.webp";
import moment from "moment";

const PrintCOE = ({
  open,
  close,
  selectedData,
  expenseFiltered,
  totalFilteredExpense,
}) => {
  const { userData } = useContext(UserInfo);
  console.log("selectedData: ", selectedData.merchantemployeeposition.position);
  return (
    <Drawer
      onClose={close}
      open={open}
      closable={false}
      bodyStyle={{
        // border: "1px solid red",
        padding: 5,
      }}
      width={window.innerWidth > 1000 ? 1000 : "100vw"}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              //   type="dashed"
              shape="circle"
              onClick={close}
              style={{ color: "#fff", backgroundColor: "#001529" }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            maxWidth: 820,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {/* {console.log("USERDATA: ", userData.data.usersmerinfo)} */}
            <div style={{ position: "absolute", top: 0, left: 0 }}>
              <Image
                width={120}
                style={{
                  marginLeft: 90,
                }}
                src={
                  userData.data.usersmerinfo.business_logo !== null
                    ? `${import.meta.env.VITE_API_IMAGE}logo/${
                        userData.data.usersmerinfo.business_logo
                      }`
                    : LogoImg
                }
                alt="logo"
              />
            </div>
            <div
              style={{
                minHeight: 120,
                maxWidth: 390,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  textAlign: "center",
                  color: "green",
                  fontSize: 16,
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                {userData.data.usersmerinfo.business_name}
              </Typography>
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: "uppercase",
                }}
              >
                {userData.data.usersmerinfo.business_street},{" "}
                {userData.data.usersmerinfo.business_barangay},{" "}
                {userData.data.usersmerinfo.business_city}
              </Typography>
              <Typography style={{ textAlign: "center", fontWeight: 500 }}>
                {userData.data.usersmerinfo.reg_contact_no}
              </Typography>
              <Typography
                style={{ textAlign: "center", color: "blue", fontWeight: 500 }}
              >
                {userData.data.email}
              </Typography>
            </div>
          </div>

          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              marginTop: 40,
            }}
          >
            <Typography
              style={{
                fontSize: 20,
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              CERTIFICATE OF EMPLOYMENT
            </Typography>
          </div>

          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              marginTop: 40,
            }}
          >
            <Typography>
              This is to certify that{" "}
              <span style={{ textTransform: "uppercase", fontWeight: 500 }}>
                {selectedData.firstname} {selectedData.lastname}
              </span>{" "}
              {/* MR. PREGIE BALASICO */}
              was employed at{" "}
              <span style={{ textTransform: "uppercase", fontWeight: 500 }}>
                {userData.data.usersmerinfo.business_name}
              </span>{" "}
              as{" "}
              <span style={{ fontWeight: 500 }}>
                {selectedData.merchantemployeeposition.position}
              </span>{" "}
              under the{" "}
              <span style={{ fontWeight: 500 }}>
                {selectedData.merchantemployeedepartment.department} Department
              </span>{" "}
              since {moment(selectedData.date_hired).format("Do of MMMM YYYY")}{" "}
              up to{" "}
              {moment(selectedData.date_stopped).format("Do of MMMM YYYY")}.
            </Typography>
          </div>

          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              //   justifyContent: "center",
              //   alignItems: "center",
              position: "relative",
              marginTop: 40,
            }}
          >
            <Typography>
              This certification is being issued as proof of his employment with
              the company.
            </Typography>
          </div>

          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              //   justifyContent: "center",
              //   alignItems: "center",
              position: "relative",
              marginTop: 40,
            }}
          >
            <Typography>
              <span style={{ textTransform: "uppercase", fontWeight: 500 }}>
                {userData.data.usersmerinfo.business_street},{" "}
                {userData.data.usersmerinfo.business_barangay},{" "}
                {userData.data.usersmerinfo.business_city}
              </span>{" "}
              this {moment().format("Do of MMMM YYYY")}.
            </Typography>
          </div>

          <div
            style={{
              //   border: "1px solid red",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              //   alignItems: "center",
              position: "relative",
              marginTop: 80,
            }}
          >
            <Typography style={{ fontWeight: 500, fontSize: 16 }}>
              {userData.data.usersmerinfo.business_authorized_name}
            </Typography>
            <Typography>
              {userData.data.usersmerinfo.business_authorized_position}
            </Typography>
          </div>

          {/* {expenseFiltered.length > 0 &&
            expenseFiltered.map((data, index) => (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div style={{ flexGrow: 1 }}>{data.expense_name}</div>
                  {!data.has_sub_info && (
                    <div style={{ marginBottom: 10 }}>
                      {parseFloat(data.expense_total_amount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </div>
                  )}
                </div>
                {data.has_sub_info &&
                  data.data.length > 0 &&
                  data.data.map((item, index2) => (
                    <div
                      key={index2}
                      style={{
                        display: "flex",
                        marginLeft: 20,
                        marginRight: 20,
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        {item.sub_info.description}
                      </div>
                      <div>
                        {parseFloat(item.amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  ))}
                {data.has_sub_info && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginTop: 10,
                    }}
                  >
                    <div style={{ flexGrow: 1 }} />
                    <div>
                      {parseFloat(data.expense_total_amount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))} */}
        </div>
        {/* <div
          style={{
            display: "flex",
            maxWidth: 600,
            width: "100%",
            borderTop: "1px solid #e5e5e5",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: 10,
              //   flexDirection: "column",
            }}
          >
            <div style={{ flexGrow: 1 }}>Total Expense:</div>
            <div>
              {parseFloat(totalFilteredExpense).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div> */}
      </div>
      {/* {console.log("totalFilteredExpense: ", totalFilteredExpense)} */}
    </Drawer>
  );
};

export default PrintCOE;
